import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import { MyContext } from "../../Components/Context";
import Pagination from "../../Components/Pagination";
import SearchField from "../../Components/Forms/SearchField";

const AnnoncesPremium = () => {


    const navigate = useNavigate()
    const [annonce, setAnnonce] = useState([])
    const [page, setPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalROws, setTotalRows] = useState(0)
    const {setActifItem} = useContext(MyContext)
    const [offer, setOffer] = useState([])
    const [search, setSearch] = useState([])
    const [selectedOffer, setSelectedOffer] = useState(null)


    const getOffers = (annonces) => {
        
        const premiumOffers = annonces
            .filter(annonce => annonce.AnnonceBoost && annonce.AnnonceBoost.length > 0)
            .map(annonce => {
                const offer = annonce.AnnonceBoost[0]?.PremiumClient?.offer; 
                if (offer) {
                    return offer;
                }
                return null; 
            })
            .filter(offer => offer !== null); 


        return premiumOffers.forEach((item) => {
            
            setOffer(prevOffers => {
            const offerExists = prevOffers.some(existingOffer => existingOffer.id === item.id);

            if (!offerExists) {
                // Si l'offre n'existe pas, on l'ajoute à la liste

                return [...prevOffers, item]; // On ajoute l'objet `item` entier
            }

            return prevOffers;
            
        })})


};



    useEffect(()=>{

        const getData = async ()=>{

            try {
                
                const data = await api.get('/get', {
                    params : {
                        page : page,
                        search : search
                    }
                });
                
                setAnnonce(data.data.rows)
                setTotalRows(data.data.count)
                setPage(page + 1)
                getOffers(data.data.rows)
                
            } catch (error) {
                console.log(error)
            }
            
        }

        getData()
        
    }, [currentPage, search])


    return(
    
        <div className="animate-fade">
            <h2 className="mb-6 text-2xl font-bold text-gray-800 dark:text-gray-100">Annonces Premium</h2>
            <div className="flex flex-row flex-wrap items-center justify-start gap-5 my-10">  
                {
                    offer.map((item, idx)=>(
                        <button className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${selectedOffer === item.id ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                            onClick={()=>{
                                
                                if(selectedOffer === item.id){
                                    setSelectedOffer(null)
                                }else{
                                    
                                    setSelectedOffer(item.id)
                                }
                            }}
                        >
                            {item.name}
                        </button>
                    ))
                }
            </div>
            {/* Table Responsive Container */}
            <div className="overflow-x-auto transition duration-300 bg-white rounded-lg shadow-sm dark:bg-gray-800">
                <table className="min-w-full text-sm text-left table-auto">
                <thead className="font-semibold text-gray-600 bg-gray-100 border-b dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600">
                    <tr>
                    <th className="px-6 py-3">Id</th>
                    <th className="px-6 py-3">Titre</th>
                    <th className="px-6 py-3">Actif</th>
                    <th className="px-6 py-3">Début</th>
                    <th className="px-6 py-3">Fin</th>
                    <th className="px-6 py-3">Offre</th>
                    </tr>
                </thead>
                <tbody className="text-gray-700 divide-y divide-gray-200 dark:text-gray-200 dark:divide-gray-600">
                    {annonce.map((item, idx)=>{ 
                        
                        if(selectedOffer === item.AnnonceBoost[0].PremiumClient.offer.id || selectedOffer == null){
                            
                            return (
                                    <tr
                                        key={idx}
                                        className="transition duration-200 ease-in-out cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-200 dark:hover:text-gray-700"
                                        onClick={() => {
                                        navigate(`/annonce/details/${item.id}`);
                                        setActifItem('Annonces');
                                        }}
                                    >
                                        <td className="flex items-center px-6 py-3 gap-x-3">
                                        <img
                                            alt={item.title}
                                            src={item.picture ? `${process.env.REACT_APP_API_PICTURE_URL}${item.picture}` : "https://randomuser.me/api/portraits/men/86.jpg"}
                                            className="w-10 h-10 border border-gray-300 rounded-full dark:border-gray-700"
                                        />
                                        </td>
                                        <td className="px-6 py-4 font-medium whitespace-nowrap">{item.title}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{item.AnnonceBoost[0].isActif ? 'Oui' : 'Non'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{new Date(item.AnnonceBoost[0].PremiumClient.startDate).toLocaleDateString()}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{new Date(item.AnnonceBoost[0].PremiumClient.endDate).toLocaleDateString()}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{item.AnnonceBoost[0].PremiumClient.offer.name}</td>
                                    </tr>
                                )
                            }
                        }

                    )}
                </tbody>
                </table>

                {/* Pagination */}
                <div className="px-4 py-3 bg-gray-50 dark:bg-gray-700">
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalROws}
                    onPageChange={() => setCurrentPage(currentPage + 1)}
                />
                </div>
            </div>
        </div>

);

}

export default AnnoncesPremium;